import { ApiService } from "./api.service";

export default class UserGemsService extends ApiService {
  constructor() {
    super("user-gems");
  }
}
